import React from 'react';
import './Event.css'

const Event = ({ eventDate, eventTitle, eventDescription, eventLocation, eventLink, eventImages = [] }) => {
    // Format date to show "February 11th - February 12th"
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <article className="c-event">
            <div className="c-event__date">
                <div className="c-event__month-day">
                    {formatDate(eventDate.start)} –
                    {formatDate(eventDate.end)}
                </div>
                <div className="c-event__year">{eventDate.year}</div>
            </div>
            <div className="c-event__body">
                <h2 className="c-event__title">{eventTitle}</h2>
                <p className="c-event__text">{eventDescription}</p>
                <div className="c-event__footer">
                    <div className="c-event__location">
                        <i className="c-icon c-icon--pin" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#30557D" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                            </svg>
                        </i>
                        {eventLocation}
                    </div>
                    {eventLink && <a href={eventLink} className="c-event__link">
                        To the trade fair page
                        <i className=" c-icon--arrow-right" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#D90F2D" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                            </svg>
                        </i>
                    </a>}
                </div>
            </div>
            {eventImages && eventImages.length > 0 && (
                <div className="c-event__images-container">
                    <div className="c-event__logo">
                        {eventImages[0].src && <img src={eventImages[0].src} alt={eventImages[0].alt} />}
                    </div>
                    <div className="c-event__main-image">
                        <img src={eventImages[1].src} alt={eventImages[1].alt} />
                    </div>
                </div>
            )}
        </article>
    );
};

export default Event;